import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	prioritySchemesDescription: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.header-description.priority-schemes-description',
		defaultMessage:
			'Associate a priority or a group of priorities with your projects. You can choose a different set of priorities for your projects by using priority schemes. {linkStart}Learn more about priority schemes{linkEnd}.',
		description: 'Information for associating priorities with priority schemes',
	},
	learnMoreLink: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.header-description.learn-more-link',
		defaultMessage: 'Learn more about priority schemes',
		description: 'Link to help docs for learning more about priority schemes',
	},
	defaultPrioritySchemeDescription: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.header-description.default-priority-scheme-description',
		defaultMessage:
			'If you haven’t associated any project with a priority scheme, a default priority scheme will be associated to the project.',
		description: 'Description for default priority scheme association with projects',
	},
	findPrioritiesDescription: {
		id: 'admin-pages-priority-schemes.priority-schemes-header.header-description.find-priorities-description',
		defaultMessage: 'You can find your priorities faster by their name or associated projects.',
		description: 'Description to find priorities by scheme name or associated projects',
	},
});
